import React, { Fragment } from "react";
import { Breadcrumbs, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import MaterialTable from "../../../components/material_table";
import { ACTUALIZAR_MANDANTE, AGREGAR_MANDANTE, ELIMINAR_MANDANTE } from "../../../constants/permissions";

function Page(props) {
	const {
		usuario,
		mandantes,
		dialog_open,
		handle_show_dialog,
		handle_eliminar,
		handle_cancelar,
		handle_export,
	} = props;

	const history = useHistory();
	const permisos = Array.from(usuario.permisos);
	const permisoActualizar = permisos.find(p => p.nombre === ACTUALIZAR_MANDANTE);
	const permisoAgregar = permisos.find(p => p.nombre === AGREGAR_MANDANTE);
	const permisoEliminar = permisos.find(p => p.nombre === ELIMINAR_MANDANTE);

	let columns = [
		{
			title: "Nombre",
			field: "nombre",
		}, {
			title: "RUT",
			field: "rut_formateado",
		}, {
			title: "Responsable",
			field: "responsable_actual.nombre_completo",
		}, {
			title: "Tipo",
			field: "tipo",
		}, {
			title: "Giro",
			field: "giro",
		}
	];

	let actions = [
		{
			icon: "edit",
			tooltip: "Editar",
			onClick: (event, row) => history.push(`/mandante/${row._id}`),
			iconProps: { style: { color: permisoActualizar ? "#757575" : null } },
			// hidden: !permisoActualizar,
			disabled: !permisoActualizar,
		}, {
			icon: "delete",
			tooltip: "Eliminar",
			onClick: (event, row) => handle_show_dialog(row._id),
			iconProps: { style: { color: permisoEliminar ? "#757575" : null } },
			// hidden: !permisoEliminar,
			disabled: !permisoEliminar,
		}, {
			icon: "add",
			tooltip: "Agregar",
			onClick: () => history.push("/mandante"),
			isFreeAction: true,
			// hidden: !permisoAgregar,
			disabled: !permisoAgregar,
		},
	];

	return (
		<Fragment>
			<Breadcrumbs separator=">">
				<Typography color="textPrimary">Módulo Mandantes</Typography>
				<Typography color="textPrimary">Listado Mandantes</Typography>
			</Breadcrumbs>

			<MaterialTable
				title="Listado de Mandantes"
				is_loading={!mandantes}
				data={mandantes}
				columns={columns}
				actions={actions}
				export_function={handle_export}
			/>
			<Dialog
				open={dialog_open}
				disableBackdropClick
				disableEscapeKeyDown
			>
				<DialogTitle>Eliminar Mandante</DialogTitle>
				<DialogContent dividers>
					<Typography>Se debe confirmar la eliminación del mandante.</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handle_eliminar} variant="contained" color="primary">Eliminar</Button>
					<Button autoFocus onClick={handle_cancelar} color="primary">Cancelar</Button>
				</DialogActions>
			</Dialog>
		</Fragment>
	);
}

export default Page;